// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const aiTimesheetGeneratedWebhookPathParamsSchema = z.object({
  account_id: z.number().int().describe("Timely Account ID"),
  user_id: z.number().int().describe("Timely User ID"),
});

export const aiTimesheetGeneratedWebhookHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("Internal AI bearer token"),
});

/**
 * @description Webhook processed
 */
export const aiTimesheetGeneratedWebhook200Schema = z.object({
  message: z.coerce.string(),
  proposal_id: z.optional(z.coerce.string()),
});

/**
 * @description Unauthorized (wrong bearer token)
 */
export const aiTimesheetGeneratedWebhook401Schema = z.unknown();

export const aiTimesheetGeneratedWebhookMutationRequestSchema = z.object({
  ticUserId: z.optional(z.coerce.string()),
  timelyUserId: z.optional(z.number().int()),
  timelyAccountId: z.optional(z.number().int()),
  date: z.string().date(),
  event: z.enum(["generation_completed", "generation_failed"]),
  generation_mode: z.optional(z.enum(["manual", "auto"])),
  message: z.optional(z.coerce.string().describe("Failure reason (event=generation_failed)")),
  timesheet_entries: z.optional(z.array(z.object({
    project_id: z.number().int().nullish(),
    note: z.coerce.string().nullish(),
    label_ids: z.optional(z.array(z.number().int())),
    resource_id: z.coerce.string().describe("The work item this entry proposes: either a TIC resource uuid or a native linked work item uri (\"timely://work-items/<id>\").").nullish(),
    entries: z.array(z.object({
      from: z.string().datetime(),
      to: z.string().datetime(),
      note: z.coerce.string().nullish(),
    })),
  })).describe("Generated entries (success path). Each carries its project, note, label ids, and the AI activity blocks.")),
  total_input_tokens: z.number().int().nullish(),
  total_output_tokens: z.number().int().nullish(),
  entries_input_tokens: z.number().int().nullish(),
  entries_output_tokens: z.number().int().nullish(),
  summaries_input_tokens: z.number().int().nullish(),
  summaries_output_tokens: z.number().int().nullish(),
  entries_cost: z.number().nullish(),
  summaries_cost: z.number().nullish(),
  total_cost: z.number().nullish(),
  provider: z.coerce.string().nullish(),
  effort: z.coerce.string().nullish(),
  interval_minutes: z.number().int().nullish(),
  note_language: z.coerce.string().nullish(),
});

export const aiTimesheetGeneratedWebhookMutationResponseSchema = z.lazy(() => aiTimesheetGeneratedWebhook200Schema);
